<template>
  <span></span>
</template>

<script>
import { annotate } from 'rough-notation'
import { getEl } from '@/utils/dot-helpers'

export default {
  name: 'TheNotation',
  props: {
    selector: {
      type: String
    },
    type: {
      type: String,
      default: 'strike-through'
    }
  },
  computed: {
    options() {
      return {
        box: {
          color: '#FF9F90',
          padding: 14,
          strokeWidth: 8,
          zIndex: 90000
        },
        underline: {
          color: '#FF9F90',
          padding: 14,
          strokeWidth: 8
        },
        highlight: {
          color: '#FFD54F',
          padding: 14,
          strokeWidth: 8
        },
        'strike-through': {
          color: '#FF9F90',
          strokeWidth: 12
        },
        'crossed-off': {
          color: 'darkRed',
          padding: 14,
          strokeWidth: 8
        }
      }
    }
  },
  watch: {
    type() {
      this.removeNotation()
      this.initNotation()
    }
  },
  mounted() {
    this.initNotation()
  },
  beforeDestroy() {
    this.removeNotation()
  },
  methods: {
    initNotation() {
      this.el = getEl(this.selector)
      if (!this.el) return
      this.notation = annotate(this.el, {
        type: this.type,
        ...this.options[this.type]
      })
      this.notation.show()
    },
    removeNotation() {
      if (!this.notation) return
      this.notation.remove()
    }
  }
}
</script>
